module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"modify":"Edit"},"fr":{"modify":"Modifier"},"de":{"modify":"Modifikator"}}')
  delete Component.options._Ctor
}
